import { render, staticRenderFns } from "./Address-Form.vue?vue&type=template&id=4c5da71f&scoped=true&"
import script from "./Address-Form.vue?vue&type=script&lang=js&"
export * from "./Address-Form.vue?vue&type=script&lang=js&"
import style0 from "./Address-Form.vue?vue&type=style&index=0&id=4c5da71f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5da71f",
  null
  
)

export default component.exports